import React, { useState, useEffect } from "react";
// componente
import OptionMySchedule from "./optionMySchedule";

export default function Schedule08Meet(props) {
  const [arrayData, setArrayData] = useState([]);

  useEffect(() => {
    if (props.mySchedule.length > 0) {
      var data = [];

      props.mySchedule.map((e) => {
        var filter = props.scheduleList.find(
          (schedule) => schedule.id === e.id
        );

        if (filter) {
          data.push(filter);
        }
      });

      setArrayData(data);
    }
  }, [props.mySchedule, props.scheduleList]);

  useEffect(() => {
    if (props.mySchedule.length === 0 && props.other) {
      props.setStepDate("e");
    }
  }, [props.mySchedule]);
  return (
    <div style={{ display: 'flex', flexDirection: 'column', padding: '5%' }}>
      {arrayData.length > 0 &&
        arrayData
          .filter((e) =>
            e.title.toLocaleLowerCase().includes(props.search.toLowerCase())
          )
          .sort((a, b) => a.startEnd.substr(0, 2) - b.startEnd.substr(0, 2))
          .map((e, i) => (
            <OptionMySchedule
              mySchedule={props.mySchedule}
              setMySchedule={props.setMySchedule}
              title={e.title}
              data={e}
            />
          ))}
    </div>
  );
}
